// dataSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import baseUrl from './baseUrl';

// Define an initial state
const initialState = {
    totalAds: [],
    totalRows: 0,
    search: [],
    status: 'idle',
    error: null
};

// Define the asynchronous action for fetching records
export const fetchTotalAds = createAsyncThunk(
    'data/fetchTotalAds',
    async currentPage => {
        const response = await axios.get(
            `${baseUrl}/ads/allAds/${currentPage}`
        ); // Replace with your API endpoint
        return response.data;
    }
);

export const fetchSortedRecords = createAsyncThunk(
    'data/fetchSortedRecords',
    async ({ userId, sortOrder, currentPage }) => {
        const response = await axios.get(
            `${baseUrl}/ads/sort/${userId}/${sortOrder}/${currentPage}`
        );
        return response.data;
    }
);

export const fetchTotalRows = createAsyncThunk(
    'data/fetchTotalRows',
    async userId => {
        const response = await axios.get(`${baseUrl}/ads/countAllAds`);
        if (response.data > 0) {
            return response.data;
        }
    }
);

export const searchAdApprovalsList = createAsyncThunk(
    'users/searchAdApprovalsList',
    async searchText => {
        const response = await axios.get(
            `${baseUrl}/ads/searchForAll?role=Advertiser&searchTerm=${searchText.trim()}`
        );
        return response.data;
    }
);

// Create a slice
const myAdsSlice = createSlice({
    name: 'data',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchTotalAds.pending, state => {
                state.status = 'loading';
            })
            .addCase(fetchTotalAds.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.totalAds = action.payload;
            })
            .addCase(fetchTotalAds.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });

        builder
            .addCase(fetchTotalRows.pending, state => {
                state.status = 'loading';
            })
            .addCase(fetchTotalRows.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.totalRows = action.payload;
            })
            .addCase(fetchTotalRows.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
        builder
            .addCase(fetchSortedRecords.pending, state => {
                state.status = 'loading';
            })
            .addCase(fetchSortedRecords.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.records = action.payload;
            })
            .addCase(fetchSortedRecords.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
        builder
            .addCase(searchAdApprovalsList.pending, state => {
                state.status = 'loading';
            })
            .addCase(searchAdApprovalsList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.search = action.payload;
            })
            .addCase(searchAdApprovalsList.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    }
});

export default myAdsSlice.reducer;
